<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">产品中心</div>
        <div class="item_small">-PRODUCT CONTER-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">{{ groupName }}</div>
        </div>
      </div>
      <div class="productList_content row-column acea-row row-center-wrapper">
        <productList :productList="productList"></productList>
      </div>
    </div>
  </div>
</template>
<script>
import productList from "@/components/productList2/index";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/productConter/topbg1.png"),
      groupName: "单相重合闸系列", //产品类型名称
      productList: [
        {
          name: "PSD16-A",
          productImg: require("@/assets/productConter/goods/single_good1.png"),
          paramsImg: require("@/assets/productConter/params/PSD16-A.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSD16-A.png"),
          size: "95*93*65",
            tableDataRight:[
            {technicalIndicators:"产品型号:",performanceDesc:'PSD16-A'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40"C-85C/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'95*93*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、欠压、过压、过流、漏电、输出、通信、防雷'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'6A-10A-16A'},
            {technicalIndicators:"输入额定电压(工作电压波动范围):",performanceDesc:'220V(150V-280V)'},
            {technicalIndicators:"输入额定电压频率(含波动范围):",performanceDesc:'50Hz(士1Hz)'},
            {technicalIndicators:"过压保护值:",performanceDesc:'275V±5V'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'270v'},
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V主5V'},
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
          ],
           tableDataLeft:[
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'>In*1.15,<25'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>In*1.15,<25'},
            {technicalIndicators:"短路保护值及动作时间:",performanceDesc:'>ln*1.15,<0.ls'},
            {technicalIndicators:"剩余动作电流值及动作时间〔漏电):",performanceDesc:'30mA, <0.1s'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流: l5mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时，自动重合闸漏电保护器立即断开;故障过后，线路如是安全，保护器会自动重新合闸通电。'},
            {technicalIndicators:"防雷击性能:",performanceDesc:'lmax=1OKA'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'},
            {technicalIndicators:"远程监控功能:",performanceDesc:'可选配RS232/RS485'}
          ]
        },
        {
          name: "PSD16-S",
          productImg: require("@/assets/productConter/goods/single_good2.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSD16-S.png"),
          paramsImg: require("@/assets/productConter/params/PSD16-S.png"),
          size: "95*93*65",
          tableDataRight:[
            {technicalIndicators:"产品型号:",performanceDesc:'PSD16-S'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85°C/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'95*93*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、欠压、过压、过流、漏电、输出、通信、防雷'},
            {technicalIndicators:"数据显示:",performanceDesc:'当前电压、电流值、故障次数、故障类型'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'6A-10A-16A'},
            {technicalIndicators:"输入额定电压(工作电压波动范围):",performanceDesc:'220V{150V-280V)'},
            {technicalIndicators:"输入额定电压频率(含波动范围):",performanceDesc:'50Hz(±1Hz)'},
            {technicalIndicators:"过压保护值:",performanceDesc:'过压保护值:'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'<270v'},
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V士5V'}
          ],
          tableDataLeft:[
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.5s'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>In*1.15,-2s'},
            {technicalIndicators:"短路保护值及动作时间:",performanceDesc:'>In*1.15,<0.ls'},
            {technicalIndicators:"剩余动作电流值及动作时间〔漏电):",performanceDesc:'30mA, <0.1s'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流: 15mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时,自动重合闸漏电保护器立即断开;故障过后,线路如是安全，保护器会自动重新合闸通电。'},
            {technicalIndicators:"防雷击性能:",performanceDesc:'lmax=10KA'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'},
            {technicalIndicators:"远程监控功能:",performanceDesc:'可选配RS232/RS485'}
          ]
        },
        {
          name: "PSD63-A",
          productImg: require("@/assets/productConter/goods/single_good3.png"),
          paramsImg: require("@/assets/productConter/params/PSD63-A.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSD63-A.png"),
          size: "95*93*65",
          tableDataRight:[
            {technicalIndicators:"产品型号:",performanceDesc:'PSD63-A'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85C/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'95*93*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、欠压、过压、过流、漏电、输出、通信、防雷'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'6A-10A-16A'},
            {technicalIndicators:"输入额定电压(工作电压波动范围):",performanceDesc:'220V(150V-280V)'},
            {technicalIndicators:"输入额定电压频率(含波动范围):",performanceDesc:'50Hz(±1Hz)'},
            {technicalIndicators:"过压保护值:",performanceDesc:'275V±5V'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'<270V'},
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V士5V'},
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'}
          ],
          tableDataLeft:[
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.5s'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>In*1.15,<2s'},
            {technicalIndicators:"剩余动作电流值及动作时间〔漏电):",performanceDesc:'30mA,<0.1s'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流:15mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时，自动重合闸漏电保护器立即断开;故障过后，线路如是安全,保护器会自动重新合闸通电。'},
            {technicalIndicators:"防雷击性能:",performanceDesc:'lmax=10KA'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'l分钟/2分钟/5分钟/30分钟/60分-10次'},
            {technicalIndicators:"远程监控功能:",performanceDesc:'可选配RS232/RS485'}
          ]
        },
         {
          name: "PSD63-S",
          productImg: require("@/assets/productConter/goods/single_good4.png"),
          paramsImg: require("@/assets/productConter/params/PSD63-S.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSD63-S.png"),
          size: "95*93*65",
          tableDataRight:[
            {technicalIndicators:"产品型号:",performanceDesc:'PSD63-S'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85°℃/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'95*93*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、欠压、过压、过流、漏电、输出、通信、防雷'},
            {technicalIndicators:"数据显示:",performanceDesc:'当前电压、电流值、故障次数、故障类型'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'6A-10A-16A'},
            {technicalIndicators:"输入额定电压(工作电压波动范围):",performanceDesc:'220V(150V-280V)'},
            {technicalIndicators:"输入额定电压频率(含波动范围):",performanceDesc:'50Hz(±1Hz)'},
            {technicalIndicators:"过压保护值:",performanceDesc:'275V±5V'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'<270v'},
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V±5V'}
          ],
          tableDataLeft:[
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.5s'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>In*1.15,<25'},
            {technicalIndicators:"短路保护值及动作时间:",performanceDesc:'=In*1.15,一0.1s'},
            {technicalIndicators:"剩余动作电流值及动作时间(漏电):",performanceDesc:'30mA,<0.1S'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流:15mA'},
            {technicalIndicators:"自动重合阐特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时,自动重合闸漏电保护器立即断开;故障过后,线路如是安全,保护器会自动重新合闸通电。'},
            {technicalIndicators:"防雷击性能:",performanceDesc:'lmax=10KA'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'},
            {technicalIndicators:"远程监控功能:",performanceDesc:'可选配RS232/RS485'}
          ]
        },
         {
          name: "PSD16-SF/W1",
          productImg: require("@/assets/productConter/goods/single_good5.png"),
          paramsImg: require("@/assets/productConter/params/PSD16-SF_W1.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSD16-SF_W1.png"),
          size: "95*93*65",
            tableDataRight:[
            {technicalIndicators:"输入额定电压:",performanceDesc:'5v-8v'},
            {technicalIndicators:"网络保护范围:",performanceDesc:'100-1000M'},
            {technicalIndicators:"Up:",performanceDesc:'95v'},
            {technicalIndicators:"产品型号:",performanceDesc:'PSD16-SF/W1'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85°C/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'95"93*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、欠压、过压、过流、漏电、输出、通信、防雷'},
            {technicalIndicators:"数据显示:",performanceDesc:'当前电压、电流值、故障次数、故障类型'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'6A-10A-16A'},
            {technicalIndicators:"输入额定电压{工作电压波动范围):",performanceDesc:'220V(150V-280V)'},
            {technicalIndicators:"输入额定电压频率(含波动范围):",performanceDesc:'50Hz(主1Hz)'},
            {technicalIndicators:"过压保护值:",performanceDesc:'275V±5V'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'<270V'},
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V±5V'}
          ],
          tableDataLeft:[
            {technicalIndicators:"标称放电电流In:",performanceDesc:'标称放电电流In:'},
            {technicalIndicators:"最大放电电流Imax:",performanceDesc:'5kA'},
            {technicalIndicators:"RJ45网络信号:",performanceDesc:'1路，可选配2路'},
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.5s'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>ln*1.15,<25'},
            {technicalIndicators:"短路保护值及动作时间:",performanceDesc:'>ln*1.15,<0.1s'},
            {technicalIndicators:"剩余动作电流值及动作时间(漏电):",performanceDesc:'30mA,<0.1S'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流:15mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时,自动重合闸漏电保护器立即断开;故障过后,线路如是安全,保护器会自动重新合闻通电。'},
            {technicalIndicators:"防雷击性能:",performanceDesc:'lmax=10KA'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'},
            {technicalIndicators:"远程监控功能:",performanceDesc:'可选配RS232/RS485'}
          ]
        },
      ],
    };
  },
  watch: {},
  components: {
    productList,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;

  background-color: #f3f3f3;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .productList_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 0%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  color: #555555;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/productConter/single.vue